import ContainsFiles from "./contains-files.ts";
import { StoreyTypologyType } from "@/models/types/storey-typology-type.ts";

class ProjectOrganisationStorey extends ContainsFiles {
    id: string;

    name: string;

    index: number;

    altimetry: number;

    isBasement: boolean;

    storeyType: StoreyTypologyType;

    constructor(id: string, name: string, altimetry: number, storeyType: StoreyTypologyType, index?: number) {
        super();
        this.id = id;
        this.name = name;
        this.altimetry = Math.round(altimetry * 100) / 100;
        this.storeyType = storeyType;

        this.isBasement = storeyType === 'INFRA';

        if (index) {
            this.index = index;
        } else {
            this.index = 0;
        }
    }
}

export default ProjectOrganisationStorey;